import WorkItemPersist from '@/domain/work-item/work-item-persist.entity';

export default class WorkItemPut extends WorkItemPersist {
  assignedTo: string;

  errorId ?: string;

  error ?: string;

  eventDate ?: string;

  constructor(obj: any) {
    super(obj);
    this.assignedTo = obj.assignedTo;
    this.errorId = obj.errorId || '';
    this.error = obj.error || '';
    this.eventDate = obj.eventDate || '';
  }

  public static of(value: any): WorkItemPut {
    return new WorkItemPut(value || {});
  }
}
